import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from 'react-query';
import setToken from '../../utils/api';
import { IApiResponse } from '../../types/IApiResponse';
import { IOrderItem } from '../../types/IOrderResponse';

export default function useGetOrderDetailsByNextStatus() {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  return useMutation<any, any, Partial<IOrderItem>>(
    ['order-next-status'],
    async (data: any) => {
      if (!data.id) {
        return null;
      }
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<IApiResponse<any>>(
        `api/orders/${data?.id}/next-status`,
      );

      if (response.status !== 200) {
        throw new Error(
          response.data?.Message ?? response.data?.message ?? 'Request failed',
        );
      }
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['order-count']);
        queryClient.invalidateQueries('order-details');
        queryClient.invalidateQueries('order-list');
      },
    },
  );
}
